import * as React from "react";
import {TrendingCategory} from "../../../../../../model/TrendingCategory";
import TrendingTagList from "../TrendingTagList/TrendingTagList";

interface TrendingTags {
    tagCategories: TrendingCategory[],
}

const TrendingTagCategory: React.FC<TrendingTags> = (props) => (
    <React.Fragment>
        {
           props.tagCategories.map((tagCategory, index) => {
               return (
                   <React.Fragment key={index}>
                       <div className="row w-100">
                           <span className="trending-section-insert-title p-1">{tagCategory.category}</span>
                       </div>
                       <TrendingTagList trendingTags={tagCategory.items} />
                   </React.Fragment>
               )
           })
        }
    </React.Fragment>
)

export default TrendingTagCategory;